import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Link, useNavigate } from "react-router-dom";
const Footer = () => {

const navigate = useNavigate()
  const Send =async()=>{
    let token = await localStorage.getItem("catzapp_token")
    if(token != null){
      navigate('/contact-support')
    }else{
      navigate('/')
    }
  }
 
  const { t } = useTranslation();

  return (
    <div className="common-footer-container space-between sticky-top " style={{}}>
    <div className="container">

      <div className="row">
        <div className="col-sm-12 text-sm-center col-lg-6 col-md-6 d-flex left">
          {/* <div>
            <Link to="" className="footer-links">
              <p className="text-white menu-label mt-1">About Us</p>
            </Link>
          </div> */}
          <div>
            <Link to="/privacy_policies" className="footer-links">
              <p className="text-white menu-label mt-1">{t('Privacy Policy')}</p>
            </Link>
          </div>
          {/* <div>
            <Link to="" className="footer-links">
              <p className="text-white menu-label mt-1">Terms & Conditions</p>
            </Link>
          </div> */}
          {/* <div>
            <Link to="" className="footer-links">
              <p className="text-white menu-label mt-1">Help</p>
            </Link>
          </div> */}
          <div>
            <span className="footer-links" onClick={()=> Send()}>
              <p className="text-white menu-label mt-1">{t('Contact Us')}</p>
            </span>
          </div>
        </div>
        <div
          className="col-sm-12 text-sm-center col-md-6 col-lg-6 flex-center right"
          style={{ flexDirection: "column"}}
        >
          {/* <div>
            <p style={{color:"#ffffff", fontWeight:"bold", fontSize:"30px"}}>LOGO</p>
          </div> */}
          <div className="w-100 footerplay">
            <a href="https://play.google.com/store/apps/details?id=com.finland">
              <img
                className="mfooter-appstore-icons"
                src="./images/playstore.png"
                alt=""
              />
            </a>
            <a href="https://apps.apple.com/in/app/catzapp-recruiter/id6453476011">
              <img
                className="mfooter-appstore-icons"
                src="./images/appstore.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Footer;
